<template>
  <div>
    <!--  弹窗  -->
    <div>
      工序删除
      <el-popconfirm title="确定删除吗？" @confirm = "gongxuRemove">
        <el-button type="text" slot="reference">删除</el-button>
      </el-popconfirm>
    </div>
    工序修改：
    <el-select v-model="optionUpdateValue" placeholder="请选择">
      <el-option
          v-for="item in options"
          :key="item.process"
          :label="item.process"
          :value="item"
          :disabled="gongxu.includes(item)">
      </el-option>
    </el-select>
    <el-select v-model="optionTabUpdateValue" v-show="optionUpdateValue.tap.length !== 0" placeholder="请选择">
      <el-option
          v-for="item in optionUpdateValue.tap"
          :key="item"
          :label="item"
          :value="item">
      </el-option>
    </el-select>
    <el-button @click="gongxuUpdate" v-show="optionUpdateValue.tap.length === 0 || optionTabUpdateValue !== ''">修改</el-button>
  </div>
</template>

<script>

import request from "@/utils/request";

export default {
  props:{
    gongxu: {
    type: Array,
    default:() => []
    },
    optionIndex: {
      gongxu: {
        type: number
      },
    },
  },
  data() {
    return {
      options: [],
      optionUpdateValue: "",
      optionTabUpdateValue: "",
    }
  },
  //加载表格
  mounted() {
    this.GetGongxu()
  },
  methods: {
    GetGongxu() {
      request.post("/GetGongxu").then(res => {
        this.options = res.data
        if (this.options.length>0){
          let gongxuOption = []
          for (let i = 0; i < this.options.length; i++) {
            gongxuOption.push(this.options[i].process)
          }
          this.gongxuOptions = gongxuOption;
        }
      })
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {
          });
    },
    gongxuUpdate() {
      if (this.optionIndex == this.gongxu.length){
        this.gongxu.push(this.optionUpdateValue)
      }else {
        this.gongxu.splice(this.optionIndex, 1,this.optionUpdateValue)
      }

      this.$emit("save",this.gongxu)
    },
    gongxuRemove() {
      this.gongxu.splice(this.optionIndex, 1)
      this.$emit("save",this.gongxu)
    },
  }
}

</script>

<style scoped>

.text {
  font-size: 14px;
}

.item {
  padding: 18px 0;
}

.box-card {
  width: 300px;
}
</style>